import { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';

import CapacityAreaChart from './CapacityChartArea';
import { getCapacityStat } from '../../api/masterdataAPI';
import { useMasterData } from '../../contexts/DataProvider';

const TANEVEK = [
  '2022/2023',
  '2023/2024',
  '2024/2025',
  '2025/2026',
  '2026/2027',
];

const CHART_TYPES = [
  { value: 'percent', label: 'Százalékos stacked area' },
  { value: 'stacked', label: 'Stacked area' },
  { value: 'area', label: 'Normál area' },
];

const CapacityStatCard = ({ tanev, oktatoSelect }) => {
  const [selectedTanev, setSelectedTanev] = useState(tanev);
  const [selectedOktato, setSelectedOktato] = useState(-1);
  const [chartType, setChartType] = useState('percent');
  const [data, setData] = useState([]);

  const { oktato } = useMasterData();

  useEffect(() => {
    async function loadData() {
      const result = await getCapacityStat(
        {
          tanev: selectedTanev,
        },
        { oktato: oktatoSelect ? selectedOktato : -1 },
      );

      setData(Array.isArray(result) ? result : []);
    }

    loadData();
  }, [selectedTanev, selectedOktato, oktatoSelect]);

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent='space-between'
          alignItems={{ xs: 'stretch', md: 'center' }}
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Box>
            <Typography variant='h6' fontWeight={700}>
              Tanóra statisztika
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              Megtartott, lemondott, nem szólt és törölt órák alakulása
            </Typography>
          </Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <FormControl size='small' sx={{ minWidth: 180 }}>
              <InputLabel>Diagram típusa</InputLabel>
              <Select
                label='Diagram típusa'
                value={chartType}
                onChange={(e) => setChartType(e.target.value)}
              >
                {CHART_TYPES.map((type) => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size='small' sx={{ minWidth: 140 }}>
              <InputLabel>Tanév</InputLabel>
              <Select
                label='Tanév'
                value={selectedTanev}
                onChange={(e) => setSelectedTanev(e.target.value)}
              >
                {TANEVEK.map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {oktatoSelect && (
              <FormControl size='small' sx={{ minWidth: 220 }}>
                <InputLabel>Oktató</InputLabel>
                <Select
                  label='Oktató'
                  value={selectedOktato}
                  onChange={(e) => setSelectedOktato(e.target.value)}
                >
                  <MenuItem value={-1}>Összes oktató</MenuItem>

                  {oktato?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Stack>
        </Stack>

        <CapacityAreaChart data={data} chartType={chartType} />
      </CardContent>
    </Card>
  );
};

export default CapacityStatCard;
